import { Injectable, inject } from '@angular/core';
import { Analytics, logEvent } from '@angular/fire/analytics';

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {
    analytics = inject(Analytics);

    sendCustomEvent(eventName: string, params: { [key: string]: any } = {}) {
        logEvent(this.analytics, eventName, params);
    }


    trackDashboardClick(dashboardId: string, clientId: string, dashboardName?: string) {
        const params = {
            dashboard_client_id: clientId,
            dashboard_id: dashboardId,
            dashboard_name: dashboardName || 'unkname'
        };
        this.sendCustomEvent('dashboard_click', params);
    }
    trackDownloadReport(type: string, name: string, dashboard: string) {
        const params = {
            report_type: type,
            report_name: name,
            dashboard_id: dashboard
        };
        this.sendCustomEvent('download_report', params);
    }
}
